import React from 'react';

interface GoogleCalendarIconProps {
  size?: number;
  className?: string;
}

const GoogleCalendarIcon: React.FC<GoogleCalendarIconProps> = ({ size = 24, className = "" }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 200 200"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <path fill="#fff" d="M152.6 47.4H47.4v105.2h105.2z"/>
      <path fill="#ea4335" d="M152.6 200l47.4-47.4h-47.4z"/>
      <path fill="#fbbc04" d="M200 47.4h-47.4v105.2H200z"/>
      <path fill="#34a853" d="M152.6 152.6H47.4V200h105.2z"/>
      <path fill="#188038" d="M0 152.6v31.6C0 192.9 7.1 200 15.8 200h31.6v-47.4H0z"/>
      <path fill="#1967d2" d="M200 47.4V15.8C200 7.1 192.9 0 184.2 0h-31.6v47.4H200z"/>
      <path fill="#4285f4" d="M152.6 0H15.8C7.1 0 0 7.1 0 15.8v136.8h47.4V47.4h105.2z"/>
      <path fill="#4285f4" d="M69 128.9c-3.9-2.7-6.7-6.5-8.2-11.6l9.2-3.8c.8 3.2 2.3 5.7 4.4 7.4 2.1 1.7 4.7 2.6 7.7 2.6 3.1 0 5.7-.9 7.9-2.7 2.2-1.8 3.3-4.1 3.3-6.9 0-2.9-1.2-5.2-3.5-7-2.3-1.8-5.2-2.7-8.7-2.7h-5.3v-9.1h4.8c3 0 5.5-.8 7.6-2.4 2-1.6 3.1-3.9 3.1-6.7 0-2.5-.9-4.6-2.8-6.1-1.9-1.5-4.2-2.3-7-2.3-2.8 0-5 .7-6.6 2.2-1.6 1.5-2.8 3.3-3.5 5.4l-9.1-3.8c1.2-3.4 3.4-6.4 6.7-9 3.3-2.6 7.4-3.9 12.5-3.9 3.7 0 7.1.7 10.1 2.2 3 1.4 5.3 3.4 7 6 1.7 2.5 2.5 5.4 2.5 8.6 0 3.2-.8 6-2.3 8.2-1.6 2.2-3.5 4-5.8 5.1v.5c3 1.2 5.6 3.2 7.5 5.8 2 2.6 3 5.8 3 9.5s-.9 7-2.8 9.9c-1.9 2.9-4.5 5.2-7.8 6.9-3.3 1.7-7.1 2.5-11.2 2.5-4.9.1-9.4-1.3-13.3-4zm56.5-45.5l-10.1 7.3-5-7.7L128.6 70h7v59.3h-9.6z"/>
    </svg>
  );
};

export default GoogleCalendarIcon;
